<script setup>
defineProps({
  compact: { type: Boolean, default: false },
  options: { type: Array, default: () => [] },
  title: { type: String, required: true },
  values: { type: Array, default: () => [] },
});

const emit = defineEmits(['toggle']);
</script>

<template>
  <fieldset>
    <legend
      class="text-sm font-semibold text-lais-text-body"
      :class="
        compact &&
        'text-xs font-bold uppercase tracking-wide text-lais-text-muted'
      "
    >
      {{ title }}
    </legend>
    <div
      class="mt-2 flex flex-wrap items-center gap-2"
      :class="compact && 'gap-2'"
    >
      <label
        v-for="option in options"
        :key="option.value"
        class="inline-flex items-center gap-1 text-xs text-lais-text-body"
      >
        <input
          type="checkbox"
          :checked="values.map(String).includes(String(option.value))"
          @change="emit('toggle', option.value)"
        />
        {{ option.label }}
      </label>
    </div>
  </fieldset>
</template>
